// Taşeron portalı — Belge Analizi inceleme paneli: salt-okur çıkarılan alan bloğu (plan S25 C6,
// `docs/plans/S25-analysis-inbox.md`; tasarım incelemesi §2.6). `DocumentAnalysisItemCard.tsx`'in
// `FieldRow`/`DerivedBlock`/`orderFields`i BİREBİR aynı kuralla burada YENİDEN yazılır (o
// dosyadan import EDİLMEZ — `FieldRow`/`orderFields` orada dışa AKTARILMAZ ve C14 o yüzeyi
// SİLECEK; bu dosya kalıcı yeni ev). S17'DEN KORUNAN kurallar (2-4 sapma yok; 1 aşağıda ürün
// sahibi kararıyla REVİZE edildi):
//   1) **REVİZE (S25) — eski kural: `confidence` HİÇBİR YERDE render edilmezdi.** Gerçek
//      bir olay bu kuralı geçersiz kıldı: bir T.C. kimlik kartında `ad` alanı model tarafından
//      "ESMAN" okundu, doğrusu "OSMAN"dı (hologram harfi bozmuştu) — o alanın KENDİ güven skoru
//      0.86 idi, aynı karttaki diğer TÜM alanlar 0.96-0.99 taşıyordu. Taşeron yanlış adı gördü,
//      hiçbir uyarı almadı, belgeyi yine de doğru kişiye bağladı (T.C. eşleşiyordu, bkz.
//      `lib/personMatch.ts` FIX 2). Ürün sahibinin İLK kararı: `confidence < 0.90` iken bir
//      alan bir UYARI İKONU + kısa düz Türkçe metin ("net okunamadı, kontrol edin") taşır —
//      SAYI (yüzde/ondalık `confidence` değeri) hâlâ HİÇBİR YERDE render EDİLMEZ, biçimsel
//      eğitim düzeyi düşük bu kullanıcı kitlesi için "0.86" ya da "%86" anlamsızdır. Tek GÖRSEL
//      kademe — İSG uzmanının eski (#33'te silinen) örnek inceleme ekranındaki 0.7/0.9 iki
//      kademeli bant BURADA KURULMAZ: bu kitle iki kademe arasında farklı davranmayacak, ikinci
//      bir kademe yalnız gürültü eklerdi (aşağıdaki REVİZE 2'DEN SONRA da geçerli — hâlâ TEK
//      ikon+metin, onu tetikleyen KURAL sayısı ikiye çıktı, o başka).
//   1b) **REVİZE 2 (bu dilim) — aynı kart, ÜÇ ayrı analiz koşusu.** OSMAN/ESMAN kartı üç kez
//      çalıştırıldı: `ad` güveni 0.86 → 0.93 → 0.90 arasında GEZİNDİ, diğer TÜM alanlar üç
//      koşuda da 0.96-0.99 bandında sabit kaldı. Üçüncü koşuda 0.90 katı `<` ile eşiği (0.90)
//      TUTTURAMADI, hiçbir uyarı çıkmadı — taşeron hiçbir sinyal görmeden yanlış adı onayladı.
//      İki kusur birden: (a) sınır katıydı, tam eşikte oturan bir değeri kaçırıyordu; (b) tek
//      ölçüt (mutlak skor) tek başına gürbüz DEĞİL — kötü alanın mutlak skoru koşu başına
//      gezinir, ama aynı belgedeki en iyi alana göre GÖRECELİ farkı üç koşuda da kararlı biçimde
//      büyük kaldı (gözlenen veri + arayüz `LOW_CONFIDENCE_ABSOLUTE_FLOOR`/
//      `LOW_CONFIDENCE_RELATIVE_GAP` sabitlerinin yanındaki notta). Düzeltme: taban 0.90'dan
//      0.95'e YÜKSELTİLDİ ve kapsayıcı `<=` yapıldı, VE aynı belgenin alanları arasında göreceli
//      bir eşik EKLENDİ — ikisinden HERHANGİ Biri tetiklerse aynı tek uyarı gösterilir.
//   2) `derived.isgEgitimValidUntil` YALNIZ kaynak alanın `parse === 'ok'` İSE render edilir
//      (`derivedSourceOk` çağıran taraftan — `AnalysisReviewPane` — gelir).
//   3) `fields` AÇIK kümedir — asla exhaustive switch; tanınmayan anahtar ham hâliyle gösterilir.
//   4) `raw`/`normalized` GÜVENİLMEZ metindir — yalnız React düz metin (KVKK).
//
// **C6 — "(BELGEDEN)" makine-okuma işareti (D6).** Kart başlığı ("Belgeden okunan alanlar")
// bunu TEK yerde, GÖRÜNÜR biçimde taşır — bir tooltip'e TAŞINMAZ (tasarım incelemesi D6/C1).
// Tarihlerin yanında `analizden` rozeti YOKTUR (AC13).

import type { DocumentAnalysisFieldDto, DocumentAnalysisFields } from '@isgportal/shared';
import { Tooltip, cn } from '@isgportal/shared';
import type { DocumentAnalysisIsgEgitimValidUntil } from '@isgportal/shared';
import { Info, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Dosya üstü not #1/#1b (REVİZE 2) — ürün sahibi eşikleri, TEK görsel kademe, İKİ kural.
 * İSG uzmanının eski (#33'te silinen) örnek inceleme ekranının gösterdiği 0.7/0.9
 * iki kademeli (`confidenceBand`) eşik BURADAN kasıtlı olarak PAYLAŞILMAZ: o yüzey farklı bir
 * izleyici (uzman, sayısal bant okuyabilir) ve farklı bir karar modeli (üç kademe) uygular; iki
 * app arasında import zaten YASAK (repo kuralı), ve tek bir sayısal değeri paylaşmak için
 * `packages/shared`e bir sabit taşımak iki BAĞIMSIZ ürün kararını yapay biçimde TEK bir kaynağa
 * bağlardı — biri ayarlanınca diğeri sessizce kayardı. Aşağıdaki iki sabit burada bilinçli
 * olarak YİNELENEN (duplicate) değerlerdir; dürüst tercih budur.
 *
 * Gözlenen veri (dosya üstü not #1b — aynı T.C. kimlik kartı, ESMAN/OSMAN, üç ayrı analiz
 * koşusu):
 *   koşu 1 — `ad` 0.86, diğer TÜM alanlar 0.96–0.99
 *   koşu 2 — `ad` 0.93, diğer TÜM alanlar 0.96–0.99
 *   koşu 3 — `ad` 0.90, diğer TÜM alanlar 0.97–0.98
 * Mutlak skor koşu başına GEZİNİR (0.86→0.93→0.90) ve iyi alanların bandına yaklaşır; aynı
 * belgedeki EN YÜKSEK güvene göre göreceli fark ise HER ÜÇÜNDE de kararlı biçimde büyük kalır.
 * Bu yüzden iki BAĞIMSIZ kuraldan HERHANGİ biri tetiklenince tek uyarı gösterilir:
 *   1. taban — mutlak, KAPSAYICI (`<=`). Eski `0.90` + strict `<`, üçüncü koşudaki 0.90'ı tam
 *      eşikte oturduğu için KAÇIRMIŞTI; taban 0.95'e yükseltildi ve kapsayıcı yapıldı.
 *   2. sapma — göreceli, belge-içi. Aynı belgedeki en yüksek güvenden ≥0.05 geride kalan alan,
 *      mutlak taban henüz aşılmasa bile UYARILIR. Tek alanlı bir belgede alanın kendisi kendi
 *      tavanıdır (fark = 0), yalnız 1. kural geçerli olur — bölme YOK, sıfır alan da güvenle
 *      atlanır (`orderedFields.length === 0` erken `return null`). */
const LOW_CONFIDENCE_ABSOLUTE_FLOOR = 0.95;
const LOW_CONFIDENCE_RELATIVE_GAP = 0.05;

// ---- alan (field) görüntü sırası — `DocumentAnalysisItemCard.tsx`'in S17-D7 sırasıyla AYNI ----
const FIELD_DISPLAY_ORDER: readonly string[] = [
  'adSoyad',
  'tcKimlikNo',
  'soyad',
  'ad',
  'soyadiAdi',
  'egitimKonusu',
  'dogumTarihi',
  'verilmeTarihi',
  'muayeneTarihi',
  'iseBaslamaTarihi',
  'egitimTarihi',
  'egitimSaati',
  'tehlikeSinifi',
  'belgeDuzenlemeTarihi',
  'belgeGecerlilikTarihi',
  'belgeSonGecerlilik',
  'sonuc',
  'kanaatSonuc',
  'firmaUnvani',
  'vergiNo',
  'sgkIsyeriSicilNo',
  'duzenlemeTarihi',
];

/** İsim alanları — `normalized` karşılaştırma İÇİN katlanmış (küçük harf/aksansız), görüntü
 * İÇİN her zaman `raw` kullanılır (bkz. `DocumentAnalysisItemCard.tsx` FIX 4 notu, aynı kural). */
const NAME_FIELD_KEYS = new Set(['ad', 'soyad', 'adSoyad', 'soyadiAdi']);

function orderFields(fields: DocumentAnalysisFields): [string, DocumentAnalysisFieldDto][] {
  const rank = (key: string) => {
    const idx = FIELD_DISPLAY_ORDER.indexOf(key);
    return idx === -1 ? FIELD_DISPLAY_ORDER.length : idx;
  };
  return Object.entries(fields)
    .map((entry, originalIndex) => ({ entry, originalIndex, rank: rank(entry[0]) }))
    .sort((a, b) => a.rank - b.rank || a.originalIndex - b.originalIndex)
    .map((x) => x.entry);
}

function FieldRow({
  fieldKey,
  field,
  documentMaxConfidence,
}: {
  fieldKey: string;
  field: DocumentAnalysisFieldDto;
  /** Aynı belgedeki TÜM alanların en yüksek `confidence`'ı — çağıran (`AnalysisExtractedFields`)
   * belge başına BİR kez hesaplar, satır başına DEĞİL (dosya üstü not #1b). */
  documentMaxConfidence: number;
}) {
  const { t } = useTranslation();
  const label = t(`docCheckField.${fieldKey}`, { defaultValue: fieldKey });
  const ok = field.parse === 'ok';
  // Dosya üstü not #1/#1b (REVİZE 2) — SAYI değil, tek bir ikon+metin uyarısı; iki BAĞIMSIZ
  // kuraldan HERHANGİ biri yeter. `field.confidence` burada da başka hiçbir yerde de render
  // EDİLMEZ (yalnız eşiklerle KARŞILAŞTIRILIR).
  const lowConfidence =
    field.confidence <= LOW_CONFIDENCE_ABSOLUTE_FLOOR ||
    documentMaxConfidence - field.confidence >= LOW_CONFIDENCE_RELATIVE_GAP;
  const value = NAME_FIELD_KEYS.has(fieldKey)
    ? field.raw
    : ok
      ? (field.normalized ?? field.raw)
      : field.raw;
  return (
    <div className="flex flex-col gap-0.5">
      <dt className="flex items-center gap-1 text-xs font-medium text-muted">
        {label}
        {/* Görev talimatı örneği: "KANAAT VE SONUÇ" bir ⓘ taşır — bu, hekimin kendi ifadesinin
            OLDUĞU GİBİ gösterildiğini açıklar (tek başına bir hata/uyarı taşımadığı için burada
            Tooltip TEK taşıyıcı olarak kabul edilir — AC21). */}
        {fieldKey === 'kanaatSonuc' ? (
          <Tooltip
            label={t('analysis.review.kanaatSonucInfoLabel')}
            content={t('analysis.review.kanaatSonucInfoContent')}
          />
        ) : null}
      </dt>
      <dd
        className={cn(
          'w-fit text-sm text-fg tnum',
          !ok && 'border-b border-dashed border-border-strong pb-0.5',
        )}
      >
        {value.length > 0 ? value : '—'}
      </dd>
      {/* Düşük güven uyarısı (dosya üstü not #1/#1b) — SAYI YOK, yalnız ikon + kısa Türkçe.
          İkon `aria-hidden` (dekoratif); yanındaki görünür metin ekran okuyucu için de yeterli
          erişilebilir ad sağlar — ayrı bir `aria-label` GEREKMEZ (aynı disiplin, altındaki
          `!ok` bloğuyla AYNI). Renk `text-fg` — tek başına duran bir uyarı glifi için `text-warning`
          YASAK (açık temada 1.55:1, `SupplierContractorGate.tsx` dosya üstü kuralıyla AYNI). */}
      {lowConfidence ? (
        <p className="flex items-start gap-1 text-xs text-fg">
          <TriangleAlert className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span>{t('analysis.field.lowConfidence')}</span>
        </p>
      ) : null}
      {!ok ? (
        <p className="flex items-start gap-1 text-xs text-muted">
          <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span>{t(`analysis.parse.${field.parse}`)}</span>
        </p>
      ) : null}
    </div>
  );
}

function DerivedBlock({
  derived,
  culture,
}: {
  derived: DocumentAnalysisIsgEgitimValidUntil;
  culture: string;
}) {
  const { t } = useTranslation();
  const formatDate = (iso: string) => {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) {
      return '—';
    }
    try {
      return new Intl.DateTimeFormat(culture, { dateStyle: 'medium' }).format(d);
    } catch {
      return iso;
    }
  };
  return (
    <div className="flex flex-col gap-2 border border-border bg-surface p-3">
      <p className="text-xs font-medium text-muted">{t('analysis.result.derivedHeading')}</p>
      <dl className="grid grid-cols-1 gap-2 sm:grid-cols-3">
        <div>
          <dt className="text-xs text-muted">{t('hazard.1')}</dt>
          <dd className="text-sm text-fg tnum">{formatDate(derived.azTehlikeli)}</dd>
        </div>
        <div>
          <dt className="text-xs text-muted">{t('hazard.2')}</dt>
          <dd className="text-sm text-fg tnum">{formatDate(derived.tehlikeli)}</dd>
        </div>
        <div>
          <dt className="text-xs text-muted">{t('hazard.3')}</dt>
          <dd className="text-sm text-fg tnum">{formatDate(derived.cokTehlikeli)}</dd>
        </div>
      </dl>
    </div>
  );
}

export function AnalysisExtractedFields({
  fields,
  derived,
  derivedSourceOk,
  culture,
  droppedCount,
}: {
  fields: DocumentAnalysisFields;
  derived: DocumentAnalysisIsgEgitimValidUntil | null;
  /** `derived !== null && fields[derived.sourceField]?.parse === 'ok'` — çağıran (`AnalysisReviewPane`)
   * hesaplar, bu bileşen İKİNCİ kez türetmez. */
  derivedSourceOk: boolean;
  culture: string;
  /** `item.droppedCount` (§20 `DocumentAnalysisItemTeachingSignal`) — ÜÇ durumlu, `null` ≠ `0`
   * (bkz. `documentAnalyses.ts` `DocumentAnalysisItemDto.droppedCount` notu). `null` = ölçülmedi
   * (katı çıkarım yolu ya da daha eski bir analiz), `0` = ölçüldü ve temiz; ikisi de aşağıdaki
   * notu BASTIRIR. Yalnız `> 0` iken bir sayfaya bağlanamayan okuma VARDIR. */
  droppedCount: number | null;
}) {
  const { t } = useTranslation();
  const orderedFields = orderFields(fields);
  const showDerived = derived !== null && derivedSourceOk;
  if (orderedFields.length === 0 && !showDerived) {
    return null;
  }
  // Dosya üstü not #1b — belge başına BİR kez (satır başına DEĞİL); tek alanlı bir belgede bu,
  // o alanın kendi `confidence`'ıdır, yani göreceli fark 0 çıkar (bkz. `FieldRow`).
  const documentMaxConfidence =
    orderedFields.length > 0 ? Math.max(...orderedFields.map(([, field]) => field.confidence)) : 0;
  return (
    // Sign-off §2.1/must-fix #2 — `DerivedBlock` bu kartın DIŞINDA, bir KARDEŞ olarak render
    // edilir. Kart başlığı "Belgeden okunan alanlar/Fields read from the document" der; üç
    // tarih ise belgeden OKUNMADI, tehlike sınıfından HESAPLANDI (`DerivedBlock`'un kendi
    // alt başlığı zaten bunu söylüyor) — biri "okundu" biri "hesaplandı" derken aynı kartın
    // içinde iç içe durmaları, güvenlik-kritik bir yüzeyde köken (provenance) iddiasıyla
    // ÇELİŞİR. Kart yalnız gerçekten okunan alanları taşır; hesaplanan tarihler kendi kutusunda,
    // hemen altında.
    <div className="flex flex-col gap-3">
      {orderedFields.length > 0 ? (
        <div className="flex flex-col gap-3 border border-border bg-surface-muted p-4">
          <p className="text-xs font-medium text-muted">{t('analysis.review.extractedHeading')}</p>
          {/* Alan sayısı sinyali (S28) — HATA/`Alert` DEĞİL: hiçbir şey bozuk değil, model bir
              alanı okudu ama bir sayfaya bağlayamadı (`mapper.ts`, iki nedeni TEK opak sayıya
              indirger — alan adı tel üstünde YOK, bu yüzden metin bir SAYI taşır, alan adı
              DEĞİL). `analysis.result.disclaimerReading`in sayfa sayısının altında oturduğu
              AYNI ağırlık (`text-sm text-muted`, ikonsuz düz paragraf) — bir uyarı ikonu ya da
              `Alert` bunu üstteki `DOCCHECK_<code>` bulgu kutusuyla (farklı bir mekanizma:
              sunucudan gelen bulgu kodları) KARIŞTIRIRDI. */}
          {droppedCount !== null && droppedCount > 0 ? (
            <p className="text-sm text-muted">
              {t('analysis.review.unplacedFields', { count: droppedCount })}
            </p>
          ) : null}
          <dl className="grid gap-x-4 gap-y-3 sm:grid-cols-2">
            {orderedFields.map(([key, field]) => (
              <FieldRow
                key={key}
                fieldKey={key}
                field={field}
                documentMaxConfidence={documentMaxConfidence}
              />
            ))}
          </dl>
        </div>
      ) : null}
      {showDerived && derived ? <DerivedBlock derived={derived} culture={culture} /> : null}
    </div>
  );
}
